import React, { useState } from "react";
import { Container, Button, Breadcrumb, Col } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import AddTrainerModal from "../../modals/hrm/training/trainers/AddTrainerModal";


export default function TrainersHeader() {
  const [show, setShow] = useState(false);

  return (
    <Container fluid className="training-page">
      <div className="training-header">
        {/* <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Trainers
            </h4>

            <Breadcrumb style={{ background: "transparent", padding: 0, margin: 0 }}>
              <Breadcrumb.Item>
                <Link to="/">
                  <RiHome6Line className="text-dark" />
                </Link>
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item className="text-dark fs-6">
                Trainers
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col> */}
  <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Trainers</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Trainers
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Trainers</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
        <Button className="add-btn" onClick={() => setShow(true)}>
          <FiPlus /> Add Trainer
        </Button>
      </div>

      {/* MODAL */}
      <AddTrainerModal show={show} onHide={() => setShow(false)} />

      <style>{`
        .training-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }

        .add-btn {
          background: #ff6b2c;
          border: none;
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 16px;
          border-radius: 6px;
        }

        .add-btn:hover {
          background: #e65a1f;
        }

        @media (max-width: 768px) {
          .training-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .add-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </Container>
  );
}